'use client'

import { WIZARD_COPY } from '../../const'
import type { PreviewSectionProps } from '../../types'

import styles from './PreviewSection.module.scss'

export function PreviewSection({ statistics }: PreviewSectionProps) {
  const { preview: copy, sections } = WIZARD_COPY

  return (
    <section className={styles.section} aria-labelledby="graft-filter-wizard-preview">
      <h3 id="graft-filter-wizard-preview" className={styles.sectionTitle}>
        {sections.preview}
      </h3>
      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <span className={styles.statValue}>{statistics.typesExposed}</span>
          <span className={styles.statLabel}>{copy.typesExposed}</span>
        </div>
        <div className={styles.statCard}>
          <span className={styles.statValue}>{statistics.methodsExposed}</span>
          <span className={styles.statLabel}>{copy.methodsExposed}</span>
        </div>
        <div className={styles.statCard}>
          <span className={styles.statValue}>{statistics.fieldsExposed}</span>
          <span className={styles.statLabel}>{copy.fieldsExposed}</span>
        </div>
      </div>

      {statistics.perType.length > 0 && (
        <ul className={styles.previewList}>
          {statistics.perType.map((type) => (
            <li key={type.fqn} className={styles.previewItem}>
              <code>{type.fqn}</code>
              <span className={type.methodCount === 0 ? styles.previewZero : styles.previewCount}>
                {type.methodCount === 0 ? copy.typeIncludedNoMethods : copy.methodCount(type.methodCount)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
